class ClassSwitcher extends HTMLElement {
  constructor() {
    super();
    this.dataset.activeIndex = 1;
    this.classNotSwitchedYet = true
  }

  connectedCallback() {
    this.$switches = this.querySelectorAll("button");
    this.$switches.forEach((classSwitcher) => classSwitcher.addEventListener("click", this.handleClassSwitch.bind(this)));
  }

  handleClassSwitch(evt) {
    this.$switchTargets = document.querySelectorAll(this.dataset.target);

    const currentSwitcher = evt.currentTarget;
    this.dataset.activeIndex = [...this.$switches].findIndex( (classSwitcher) => classSwitcher === currentSwitcher) + 1;
    const otherSwitches = [...this.$switches].filter( (classSwitcher) => classSwitcher !== currentSwitcher);

    otherSwitches.forEach((classSwitcher) => {
      const classesToRemove = classSwitcher.dataset.classlist;
      if (classesToRemove === "") return;
      this.$switchTargets.forEach((target) => target.classList.remove(...classesToRemove.split(" ")))
    });


    if (!currentSwitcher.dataset.classlist) return;

    let classesToAdd = []
    classesToAdd = currentSwitcher.dataset.classlist?.split(" ");
    this.$switchTargets.forEach((target) => target.classList.add(...classesToAdd))

    if(this.classNotSwitchedYet) {
      document.dispatchEvent(new CustomEvent('class:switched', { detail: {target: this.dataset.target, index: this.dataset.target}}));
      this.classNotSwitchedYet = false
    }
  }
}

customElements.define("class-switcher", ClassSwitcher);
